import React from "react";
import PropTypes from "kf-proptypes/widgets";

import styles from "./badge.css";

export const BADGE_COLORS = {
  MAGENTA: "magenta",
  RED: "red",
  ORANGE: "orange",
  BITTERSWEET: "bittersweet",
  BLUE: "blue",
  WHITE: "white",
  GRAY: "gray"
};

export const BADGE_SHAPES = {
  BOX: "box",
  DOT: "dot",
  CIRCLE: "circle"
};

export const BADGE_SIZES = {
  MEDIUM: "medium",
  SMALL: "small"
};

export const BADGE_TYPES = {
  FILLED: "filled",
  OUTLINE: "outline"
};

/**
 * Use this component to show the badges on any other component
 */
export function Badge(props) {
  const {
    count = 0,
    maxCount = 9,
    text = "",
    className,
    icon,
    shape = BADGE_SHAPES.CIRCLE,
    color = BADGE_COLORS.BLUE,
    size = BADGE_SIZES.SMALL,
    type = BADGE_TYPES.FILLED
  } = props;
  const countValue = count <= maxCount ? count : `${maxCount}+`;

  if (type === BADGE_TYPES.OUTLINE) {
    return (
      <div
        className={`${className} ${styles.badge} ${styles[color]} ${styles.outline}`}
      >
        {text}
        {count > 0 && countValue}
        {icon && <span className={styles.iconContainer}>{icon}</span>}
      </div>
    );
  }

  return (
    count > 0 && (
      <div
        className={`${className} ${styles.badge} ${styles.filled} ${styles[shape]} ${styles[size]} ${styles[color]}`}
      >
        {countValue}
      </div>
    )
  );
}

Badge.propTypes = {
  /** value of badge */
  count: PropTypes.number,
  /** number after which badge will not show the count */
  maxCount: PropTypes.number,
  /** badge text */
  text: PropTypes.string,
  /** custom classname to customize the positioning of badge */
  className: PropTypes.string,
  /** Shape of the badge */
  shape: PropTypes.oneOf(Object.values(BADGE_SHAPES)),
  /** Color of the badge */
  color: PropTypes.oneOf(Object.values(BADGE_COLORS)),
  /** Size of the badge */
  // size: PropTypes.string,
  size: PropTypes.oneOf(Object.values(BADGE_SIZES)),
  /** Type of the badge */
  type: PropTypes.oneOf(Object.values(BADGE_TYPES)),
  /** Badge icon to be displayed */
  icon: PropTypes.node
};

Badge.defaultProps = {
  count: 0,
  maxCount: 9,
  size: BADGE_SIZES.SMALL,
  shape: BADGE_SHAPES.CIRCLE,
  color: BADGE_COLORS.BLUE
};
